"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Carousel/index.ts
var Carousel_exports = {};
__export(Carousel_exports, {
  Carousel: () => Carousel,
  CarouselGroupedNavigator: () => CarouselGroupedNavigator,
  CarouselIndicators: () => CarouselIndicators,
  CarouselItem: () => CarouselItem,
  CarouselNavigatorContainer: () => CarouselNavigatorContainer,
  CarouselNavigatorIcon: () => CarouselNavigatorIcon,
  IndicatorSpan: () => IndicatorSpan,
  NavigatorIcon: () => NavigatorIcon,
  useCarousel: () => useCarousel
});
module.exports = __toCommonJS(Carousel_exports);

// src/components/Carousel/Carousel.tsx
var import_react5 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faChevronLeft = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [384, 512, [9001], "f053", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
};
var faChevronRight = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [384, 512, [9002], "f054", "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
};

// src/components/Carousel/CarouselGroupedNavigator.tsx
var import_react3 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));

// src/components/Carousel/CarouselNavigatorContainer.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
function CarouselNavigatorContainer({
  className,
  children,
  onClick,
  disabled = false
}) {
  return /* @__PURE__ */ import_react.default.createElement(
    "span",
    {
      className: (0, import_classnames.default)("carousel-navigator-container", className, [
        "v2-absolute v2-text-black v2-cursor-pointer",
        "-v2-translate-y-1/2 v2-flex v2-top-1/2 v2-items-center"
      ]),
      onClick: disabled ? void 0 : onClick
    },
    children
  );
}

// src/components/Carousel/CarouselNavigatorIcon.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var import_styled = __toESM(require("@emotion/styled"));

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/Carousel/CarouselNavigatorIcon.tsx
var NavigatorIcon = (0, import_styled.default)(import_react_fontawesome.FontAwesomeIcon)`
  ${({
  chevronColor = colors.neutral[900],
  chevronHoverColor = colors.neutral[900]
}) => `
    color: ${chevronColor};

    &:hover {
      color: ${chevronHoverColor};
    }
   
  `}
`;
function CarouselNavigatorIcon({
  disabled = false,
  icon,
  className,
  onClick,
  chevronColor,
  chevronHoverColor
}) {
  if (!icon)
    return /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null);
  return /* @__PURE__ */ import_react2.default.createElement(
    NavigatorIcon,
    {
      icon,
      className: (0, import_classnames2.default)(
        "carousel-navigator-icon",
        className,
        "v2-text-[38px] v2-w-8 v2-select-none v2-transition-all",
        {
          "!v2-text-neutral-300 v2-cursor-not-allowed": disabled
        }
      ),
      onClick: disabled ? void 0 : onClick,
      chevronColor,
      chevronHoverColor
    }
  );
}

// src/components/Carousel/CarouselGroupedNavigator.tsx
function CarouselGroupedNavigator({
  className,
  leftNavigatorProps,
  leftNavigatorComponent,
  rightNavigatorProps,
  rightNavigatorComponent
}) {
  return /* @__PURE__ */ import_react3.default.createElement("div", { className: (0, import_classnames3.default)("carousel-grouped-navigator", className) }, /* @__PURE__ */ import_react3.default.createElement(
    CarouselNavigatorContainer,
    __spreadProps(__spreadValues({}, leftNavigatorProps), {
      className: (0, import_classnames3.default)(leftNavigatorProps == null ? void 0 : leftNavigatorProps.containerClassName, "v2-left-1")
    }),
    leftNavigatorComponent != null ? leftNavigatorComponent : /* @__PURE__ */ import_react3.default.createElement(CarouselNavigatorIcon, __spreadValues({}, leftNavigatorProps))
  ), /* @__PURE__ */ import_react3.default.createElement(
    CarouselNavigatorContainer,
    __spreadProps(__spreadValues({}, rightNavigatorProps), {
      className: (0, import_classnames3.default)(rightNavigatorProps == null ? void 0 : rightNavigatorProps.containerClassName, "v2-right-1")
    }),
    rightNavigatorComponent != null ? rightNavigatorComponent : /* @__PURE__ */ import_react3.default.createElement(CarouselNavigatorIcon, __spreadValues({}, rightNavigatorProps))
  ));
}

// src/components/Carousel/CarouselIndicators.tsx
var import_react4 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var import_styled2 = __toESM(require("@emotion/styled"));
var IndicatorSpan = import_styled2.default.span`
  ${({
  active = false,
  indicatorColor = colors.neutral[300],
  indicatorActiveColor = colors.yellow[500]
}) => `
    ${!active ? `background-color: ${indicatorColor} !important;` : ""}
    ${active ? `background-color: ${indicatorActiveColor} !important;` : ""}
  `}
`;
function CarouselIndicators({
  activeIndex,
  items,
  onClick,
  indicatorComponent,
  className,
  indicatorColor,
  indicatorActiveColor
}) {
  const indicatorsComponent = () => {
    const indicators = [];
    for (let i = 1; i <= items; i++) {
      indicators.push(
        /* @__PURE__ */ import_react4.default.createElement("span", { key: `indicator-container-${i}` }, indicatorComponent != null ? indicatorComponent : /* @__PURE__ */ import_react4.default.createElement(
          IndicatorSpan,
          {
            active: activeIndex === i - 1,
            key: `indicator-${i}`,
            onClick: () => onClick(i - 1),
            className: (0, import_classnames4.default)(
              "carousel-indicator-item",
              "v2-w-[15px] v2-h-[15px] v2-rounded-full v2-block",
              "v2-cursor-pointer v2-transition-all"
            ),
            indicatorColor,
            indicatorActiveColor
          }
        ))
      );
    }
    return indicators;
  };
  return /* @__PURE__ */ import_react4.default.createElement(
    "div",
    {
      className: (0, import_classnames4.default)("carousel-indicators-container", className, [
        "v2-flex v2-flex-row v2-gap-x-3 v2-gap-y-4 v2-py-2.5",
        "v2-flex-wrap v2-items-center v2-justify-center"
      ])
    },
    indicatorsComponent()
  );
}

// src/components/Carousel/Carousel.tsx
var poweredByBonjoroIcon = "https://cdn.bonjoro.com/assets/icons/powered-by-bj.svg";
function Carousel(_a) {
  var _b = _a, {
    activeIndex,
    setActiveIndex,
    setToPrev: onPrevClick,
    setToNext: onNextClick,
    carouselRef,
    transitionDuration = 300,
    children,
    overflowClassName,
    overflowStyle,
    containerClassName,
    className,
    groupedNavigatorClassName,
    items,
    hideNavigator = false,
    hideIndicators = false,
    hideBonjoroBadge = false,
    bonjoroBadgeIconClassName,
    styleProps,
    onBonjoroBadgeClick,
    leftNavigatorProps,
    leftNavigatorComponent,
    rightNavigatorProps,
    rightNavigatorComponent,
    indicatorComponent
  } = _b, otherProps = __objRest(_b, [
    "activeIndex",
    "setActiveIndex",
    "setToPrev",
    "setToNext",
    "carouselRef",
    "transitionDuration",
    "children",
    "overflowClassName",
    "overflowStyle",
    "containerClassName",
    "className",
    "groupedNavigatorClassName",
    "items",
    "hideNavigator",
    "hideIndicators",
    "hideBonjoroBadge",
    "bonjoroBadgeIconClassName",
    "styleProps",
    "onBonjoroBadgeClick",
    "leftNavigatorProps",
    "leftNavigatorComponent",
    "rightNavigatorProps",
    "rightNavigatorComponent",
    "indicatorComponent"
  ]);
  const ref = carouselRef != null ? carouselRef : (0, import_react5.useRef)(null);
  const showFooter = !hideIndicators || !hideBonjoroBadge;
  const navigatorIconStyleProps = {
    chevronColor: styleProps == null ? void 0 : styleProps.chevronColor,
    chevronHoverColor: styleProps == null ? void 0 : styleProps.chevronHoverColor
  };
  return /* @__PURE__ */ import_react5.default.createElement(
    "div",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames5.default)(
        "carousel-container",
        containerClassName,
        "v2-flex v2-flex-col v2-gap-y-2"
      )
    }),
    /* @__PURE__ */ import_react5.default.createElement(
      "div",
      {
        className: (0, import_classnames5.default)(
          "carousel-overflow",
          overflowClassName,
          "v2-overflow-hidden v2-relative"
        ),
        style: overflowStyle
      },
      /* @__PURE__ */ import_react5.default.createElement(
        "ul",
        {
          ref,
          className: (0, import_classnames5.default)(
            "carousel",
            className,
            "v2-p-0 v2-m-0 v2-whitespace-nowrap v2-transition v2-relative v2-h-full"
          ),
          style: {
            transform: `translateX(-${activeIndex * 100}%)`,
            transitionDuration: `${transitionDuration}ms`
          }
        },
        import_react5.default.Children.map(children, (child) => {
          if (child == null)
            return;
          return import_react5.default.cloneElement(child);
        })
      ),
      !hideNavigator && /* @__PURE__ */ import_react5.default.createElement(
        CarouselGroupedNavigator,
        {
          className: groupedNavigatorClassName,
          leftNavigatorComponent,
          leftNavigatorProps: __spreadProps(__spreadValues(__spreadValues({}, leftNavigatorProps), navigatorIconStyleProps), {
            icon: faChevronLeft,
            onClick: onPrevClick,
            disabled: activeIndex == 0
          }),
          rightNavigatorComponent,
          rightNavigatorProps: __spreadProps(__spreadValues(__spreadValues({}, rightNavigatorProps), navigatorIconStyleProps), {
            icon: faChevronRight,
            onClick: onNextClick,
            disabled: activeIndex + 1 == items
          })
        }
      )
    ),
    showFooter && /* @__PURE__ */ import_react5.default.createElement("div", { className: "carousel-footer v2-flex v2-flex-row v2-gap-x-4 v2-items-center v2-justify-center" }, !hideBonjoroBadge && /* @__PURE__ */ import_react5.default.createElement(
      "img",
      {
        className: (0, import_classnames5.default)(
          "carousel-bonjoro-badge",
          bonjoroBadgeIconClassName,
          "v2-h-8 v2-w-24 v2-cursor-pointer v2-select-none"
        ),
        src: poweredByBonjoroIcon,
        onClick: onBonjoroBadgeClick
      }
    ), !hideIndicators && /* @__PURE__ */ import_react5.default.createElement(
      CarouselIndicators,
      {
        indicatorComponent,
        activeIndex,
        items,
        onClick: setActiveIndex,
        indicatorColor: styleProps == null ? void 0 : styleProps.indicatorColor,
        indicatorActiveColor: styleProps == null ? void 0 : styleProps.indicatorActiveColor
      }
    ))
  );
}

// src/components/Carousel/CarouselItem.tsx
var import_react6 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));
function CarouselItem({
  children,
  className,
  outerClassName,
  innerClassName
}) {
  return /* @__PURE__ */ import_react6.default.createElement(
    "div",
    {
      className: (0, import_classnames6.default)("carousel-item", className, [
        "v2-w-full v2-h-full v2-inline-flex"
      ])
    },
    /* @__PURE__ */ import_react6.default.createElement(
      "div",
      {
        className: (0, import_classnames6.default)("carousel-item-outer", outerClassName, [
          "v2-w-full v2-h-full v2-relative v2-items-center v2-justify-center"
        ])
      },
      /* @__PURE__ */ import_react6.default.createElement(
        "div",
        {
          className: (0, import_classnames6.default)(
            "carousel-item-inner",
            innerClassName,
            "v2-w-full v2-h-full v2-absolute"
          )
        },
        children
      )
    )
  );
}

// src/hook/use-child-observer-hook.ts
var import_react7 = require("react");
function useChildObserver({ ref, onChange }) {
  const mutationObserver = new MutationObserver((mutationsList) => {
    if (ref == null ? void 0 : ref.current) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          onChange == null ? void 0 : onChange();
        }
      }
    }
  });
  (0, import_react7.useEffect)(() => {
    if (ref == null ? void 0 : ref.current) {
      mutationObserver.observe(ref.current, { childList: true });
      return () => {
        mutationObserver.disconnect();
      };
    }
  }, [ref == null ? void 0 : ref.current]);
}

// src/components/Carousel/use-carousel-hook.tsx
var import_react8 = require("react");
function useCarousel(carouselRef, options) {
  const [activeIndex, setActiveIndex] = (0, import_react8.useState)(0);
  const [items, setItems] = (0, import_react8.useState)(0);
  (0, import_react8.useEffect)(() => {
    if (carouselRef == null ? void 0 : carouselRef.current) {
      setItems(carouselRef == null ? void 0 : carouselRef.current.childElementCount);
    }
  }, []);
  const updateActiveIndex = (index) => {
    if (index < 0) {
      index = items - 1;
    } else if (index >= items) {
      index = 0;
    }
    setActiveIndex(index);
  };
  useChildObserver({
    ref: carouselRef,
    onChange: () => {
      var _a;
      if (carouselRef == null ? void 0 : carouselRef.current) {
        setItems((_a = carouselRef == null ? void 0 : carouselRef.current) == null ? void 0 : _a.children.length);
        if (options == null ? void 0 : options.resetIndexOnItemsChange) {
          setActiveIndex(0);
        }
      }
    }
  });
  (0, import_react8.useEffect)(() => {
    if (items > 0 && activeIndex > items - 1) {
      setActiveIndex(items - 1);
    }
  }, [items, activeIndex]);
  return {
    activeIndex,
    setActiveIndex: updateActiveIndex,
    setToFirst: () => updateActiveIndex(0),
    setToLast: () => updateActiveIndex(items - 1),
    setToNext: () => updateActiveIndex(activeIndex + 1),
    setToPrev: () => updateActiveIndex(activeIndex - 1),
    items
  };
}
